import { Image, View } from "@react-pdf/renderer"
import staticPath from "../../config/staticPath"
import Separator from "./Separator"

export const Header = () => {
  return (
    <>
      <View
        style={{
          padding: "30px 0 60px 0",
          display: "flex",
          width: "100%",
          flexDirection: "row",
          justifyContent: "flex-end",
        }}
        fixed
      >
        <Image
          cache={false}
          style={{
            height: 40,
            width: 104,
          }}
          src={{
            uri: staticPath("/images/logo-color.png"),
            method: "GET",
            headers: {},
            body: "",
          }}
        />
      </View>

      <Separator />
    </>
  )
}
